export default "__VITE_ASSET__BeqWpl1K__"